/* Bucéfalo UX round 2: presentation only; preserve provider rating and count. */
(function(){
 'use strict';
 if(window.buceR2ReviewPresentation) return;
 window.buceR2ReviewPresentation=true;
 function audioPlayers(scope){
  if(!scope?.querySelectorAll) return;
  scope.querySelectorAll(':is(#cont-rl-w,#content-rl-w) audio').forEach(function(audio){
   if(audio.closest('.buce-review-audio')) return;
   var label=document.querySelector('[data-buce-review-audio]')?.dataset.buceReviewAudio || '';
   var wrapper=document.createElement('div');wrapper.className='buce-review-audio';
   var play=document.createElement('button');play.type='button';play.textContent='▶ '+label;play.setAttribute('aria-pressed','false');
   var seek=document.createElement('input');seek.type='range';seek.min='0';seek.max='100';seek.value='0';seek.setAttribute('aria-label',label);
   var time=document.createElement('small');time.textContent='0:00';
   audio.before(wrapper);wrapper.append(audio,play,seek,time);audio.controls=false;audio.preload='metadata';
   var clock=function(value){return Math.floor(value/60)+':'+String(Math.floor(value%60)).padStart(2,'0');};
   var sync=function(){
    var playing=!audio.paused;play.textContent=(playing?'Ⅱ ':'▶ ')+label;play.setAttribute('aria-pressed',String(playing));
    if(Number.isFinite(audio.duration) && audio.duration>0){seek.value=String(100*audio.currentTime/audio.duration);time.textContent=clock(audio.currentTime)+' / '+clock(audio.duration);}
   };
   play.addEventListener('click',function(){
    if(!audio.paused){audio.pause();return;}
    document.querySelectorAll('.buce-review-audio audio').forEach(function(other){if(other!==audio) other.pause();});
    audio.play().catch(function(){sync();});
   });
   seek.addEventListener('input',function(){if(Number.isFinite(audio.duration)) audio.currentTime=audio.duration*Number(seek.value)/100;});
   ['play','pause','timeupdate','loadedmetadata','ended'].forEach(function(name){audio.addEventListener(name,sync);});
  });
 }
 function numericRatings(scope){
  if(!scope || !scope.querySelectorAll) return;
  var selector='.sectionRevieWidget3 .rv-stars, :is(#cont-rl-w,#content-rl-w) #revieList .rv-stars, .t4s-product__info-container .rvst-stars';
  var stars=[];
  if(scope.nodeType===1 && scope.matches(selector)) stars.push(scope);
  stars.push.apply(stars,scope.querySelectorAll(selector));
  stars.forEach(function(el){
   var raw=el.style.getPropertyValue('--rating');
   if(el.classList.contains('rvst-stars')){
    var title=el.parentElement.getAttribute('title') || '';
    var match=title.match(/^([0-5](?:[.,]\d+)?)/);
    raw=match?match[1].replace(',','.'):'';
   }
   if(!raw || !isFinite(Number(raw))) return;
   var rating=Number(raw);
   if(rating<0 || rating>5) return;
   var copy=String(Math.round(rating*100)/100)+' / 5';
   var score=el.nextElementSibling;
   if(!score || !score.classList.contains('buce-review-score')){
    score=document.createElement('span');score.className='buce-review-score';el.after(score);
   }
   if(!score.querySelector('.buce-review-score__value')){
    score.textContent='';
    var icon=document.createElementNS('http://www.w3.org/2000/svg','svg');
    icon.setAttribute('viewBox','0 0 24 24');icon.setAttribute('aria-hidden','true');icon.setAttribute('focusable','false');
    icon.classList.add('buce-review-score__star');
    var path=document.createElementNS('http://www.w3.org/2000/svg','path');
    path.setAttribute('d','M12 2.5 15 8.6 21.7 9.6 16.8 14.3 18 21 12 17.8 6 21 7.2 14.3 2.3 9.6 9 8.6Z');
    icon.append(path);
    var value=document.createElement('span');value.className='buce-review-score__value';
    score.append(icon,value);
   }
   var value=score.querySelector('.buce-review-score__value');
   if(value.textContent!==copy) value.textContent=copy;
   el.classList.add('buce-rating-read');el.setAttribute('aria-hidden','true');
  });
 }
 function reviewPreviews(scope){
  if(!scope?.querySelectorAll) return;
  var labels=document.querySelector('[data-buce-review-more]')?.dataset;
  if(!labels?.buceReviewMore || !labels.buceReviewLess) return;
  scope.querySelectorAll(':is(#cont-rl-w,#content-rl-w) .detail-star:not(.detail-star-ia)').forEach(function(card){
   var text=card.querySelector('.commentRevie');
   if(!text) return;
   card.classList.add('buce-review-preview');
   var button=card.querySelector('.buce-review-more');
   var expanded=card.classList.contains('is-expanded');
   var overflows=text.scrollHeight>text.clientHeight+1;
   if(!expanded && !overflows){
    if(button) button.hidden=true;
    return;
   }
   if(!button){
    button=document.createElement('button');button.type='button';button.className='buce-review-more';
    if(text.id) button.setAttribute('aria-controls',text.id);
    text.after(button);
    button.addEventListener('click',function(){
     var open=card.classList.toggle('is-expanded');
     button.setAttribute('aria-expanded',String(open));
     button.textContent=open?labels.buceReviewLess:labels.buceReviewMore;
    });
   }
   button.hidden=false;
   button.setAttribute('aria-expanded',String(expanded));
   var copy=expanded?labels.buceReviewLess:labels.buceReviewMore;
   if(button.textContent!==copy) button.textContent=copy;
  });
 }
 function mediaFirst(scope){
  scope.querySelectorAll(':is(#cont-rl-w,#content-rl-w) #revieList').forEach(function(list){
   var cards=Array.from(list.children).filter(function(el){return el.matches('.detail-star:not(.detail-star-ia)');});
   var priority=function(card){
    if(card.querySelector('.content-media-revie img[data-open="img"],.content-media-revie .imgn-rv img:not(.img-convert):not(.img-play-revie)')) return 0;
    if(card.querySelector('audio')) return 1;
    return 2;
   };
   var date=function(card){return card.querySelector('.content-flex-wrap label')?.textContent.trim() || '';};
   var sorted=cards.slice().sort(function(a,b){return priority(a)-priority(b) || date(b).localeCompare(date(a));});
   if(sorted.every(function(card,i){return card===cards[i];})) return;
   var marker=document.createTextNode('');cards[0].before(marker);
   sorted.forEach(function(card){marker.before(card);});marker.remove();
  });
 }
 function compact(scope){
  audioPlayers(scope);
  numericRatings(scope);
  reviewPreviews(scope);
  mediaFirst(scope);
  var nodes=[];
  if(scope.nodeType===1 && scope.matches('.t4s-product [id="revieStar"] span')) nodes.push(scope);
  if(scope.querySelectorAll) nodes.push.apply(nodes,scope.querySelectorAll('.t4s-product [id="revieStar"] span'));
  nodes.forEach(function(el){
   var match=el.textContent.trim().match(/^([\d.,\s]+)\s+Reseñas?$/i);
   if(!match) return;
   var count=match[1].trim();
   el.setAttribute('aria-label',count+' reseñas');
   el.textContent='('+count+')';
  });
 }
 function init(){
  var root=document.getElementById('MainContent');
  if(!root) return;
  compact(root);
  var queued=false;
  function schedule(){
   if(queued) return;
   queued=true;
   requestAnimationFrame(function(){queued=false;compact(root);});
  }
  new MutationObserver(schedule).observe(root,{childList:true,subtree:true,characterData:true});
  root.addEventListener('click',schedule);
  root.addEventListener('transitionend',schedule);
  window.addEventListener('resize',schedule,{passive:true});
  window.addEventListener('load',schedule,{once:true});
  document.fonts?.ready.then(schedule);
 }
 if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true});
 else init();
})();

